import { TamediaStyles } from '@ta-interaktiv/microfrontend-template-helpers'
import styled from 'styled-components'
import { TextWidth, TextWidthExtended } from '@ta-interaktiv/react-disco-grid'
import { GlobalVariables } from 'Globals/GlobalVariables'
import { VirusShareTable } from 'components/VirusShareTable'
import { VirusOverTime } from 'components/VirusOverTime'
import { SummaryText } from 'components/SummaryText'
import { CovidOverTime } from 'components/CovidOverTime'
import { ConsultationOverTime } from 'components/ConsultationOverTime'
import { InluenzaSeason } from 'components/InluenzaSeason'
import { WasteWaterCovid } from 'components/WasteWaterCovid'
import { WasteWaterInfluenza } from 'components/WasteWaterInfluenza'
import { WasteWaterRSV } from 'components/WasteWaterRSV'
import { ReactNode } from 'react'
import { ChartFrame } from 'components/ChartFrame'
import { global_locales } from 'components/constants'
import { VirusShareHeatmap } from 'components/VirusShareHeatmap'
import { TrendAlternative } from 'components/TrendAlternative'

var debug = window.document.title === 'TA-Interaktiv Microfrontend'
var locales = global_locales
const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  var part = properties?.part || 'none'
  return (
    <AppContainer $colorMode={colorMode}>
      {part === 'consultationovertime' && (
        <TextWidth>
          <ConsultationOverTime colorMode={colorMode} lang={tenant.lang} />
        </TextWidth>
      )}
      {part === 'rankalternative' && (
        <TextWidthExtended>
          <VirusShareHeatmap colorMode={colorMode} lang={tenant.lang} />
        </TextWidthExtended>
      )}
      {part === 'trendalternative' && (
        <TextWidth>
          <TrendAlternative
            colorMode={colorMode}
            lang={tenant.lang}
            type='sars-cov-2'
          />
        </TextWidth>
      )}
      {part === 'trendalternative' && (
        <TextWidth>
          <TrendAlternative
            colorMode={colorMode}
            lang={tenant.lang}
            type='influenza'
          />
        </TextWidth>
      )}
      {part === 'trendalternative' && (
        <TextWidth>
          <TrendAlternative
            colorMode={colorMode}
            lang={tenant.lang}
            type='respiratory_syncytial_virus'
          />
        </TextWidth>
      )}
      {/* 
      ############################
      #########  SINGLES  #########
      ############################
      */}
      {part === 'summary' && (
        <TextWidth>
          <SummaryText colorMode={colorMode} lang={tenant.lang} />
        </TextWidth>
      )}
      {part === 'overtime' && (
        <TextWidthExtended>
          <VirusOverTime colorMode={colorMode} lang={tenant.lang} />
        </TextWidthExtended>
      )}
      {part === 'ranking' && (
        <TextWidth>
          <VirusShareTable colorMode={colorMode} lang={tenant.lang} />
        </TextWidth>
      )}
      {part === 'wastewatercovid' && (
        <TextWidth>
          <WasteWaterCovid colorMode={colorMode} lang={tenant.lang} />
        </TextWidth>
      )}
      {part === 'wastewaterinfluenza' && (
        <TextWidth>
          <WasteWaterInfluenza colorMode={colorMode} lang={tenant.lang} />
        </TextWidth>
      )}
      {part === 'wastewaterrsv' && (
        <TextWidth>
          <WasteWaterRSV colorMode={colorMode} lang={tenant.lang} />
        </TextWidth>
      )}
      {part === 'covid' && (
        <TextWidth>
          <CovidOverTime colorMode={colorMode} lang={tenant.lang} />
        </TextWidth>
      )}
      {part === 'influenza' && (
        <TextWidth>
          <InluenzaSeason colorMode={colorMode} lang={tenant.lang} />
        </TextWidth>
      )}

      {/* 
      ############################
      #########  BLOCKS  #########
      ############################
      */}
      {(part === 'introblock' || debug) && (
        <Block style='b'>
          <SummaryText colorMode={colorMode} lang={tenant.lang} />
          <ConsultationOverTime colorMode={colorMode} lang={tenant.lang} />
          <VirusShareTable colorMode={colorMode} lang={tenant.lang} />
          {/* <VirusCumulated colorMode={colorMode} lang={tenant.lang} /> */}
          {/* <Hospitalized colorMode={colorMode} lang={tenant.lang} /> */}
          {/* <Hospitalized colorMode={colorMode} lang={tenant.lang} /> */}
        </Block>
      )}
      {(part === 'covidblock' || debug) && (
        <Block title={locales.block_titles[tenant.lang].covid} style='b'>
          <ChartFrame
            lang={tenant.lang}
            title={locales.wastewater[tenant.lang].title}
            lead={locales.wastewater[tenant.lang].lead}
          >
            {/* <Trend colorMode={colorMode} lang={tenant.lang} type='sars-cov-2' /> */}
            <WasteWaterCovid colorMode={colorMode} lang={tenant.lang} />
          </ChartFrame>
          <CovidOverTime colorMode={colorMode} lang={tenant.lang} />
        </Block>
      )}
      {(part === 'influenzablock' || debug) && (
        <Block style='b' title={locales.block_titles[tenant.lang].influenza}>
          {/* <Trend colorMode={colorMode} lang={tenant.lang} type='influenza' /> */}
          <WasteWaterInfluenza colorMode={colorMode} lang={tenant.lang} />
          <InluenzaSeason colorMode={colorMode} lang={tenant.lang} />
        </Block>
      )}
      {(part === 'rsvblock' || debug) && (
        <Block title={locales.block_titles[tenant.lang].rsv} style='b'>
          {/* <Trend
            colorMode={colorMode}
            lang={tenant.lang}
            type='respiratory_syncytial_virus'
          /> */}
          <WasteWaterRSV colorMode={colorMode} lang={tenant.lang} />
        </Block>
      )}
      {/* {(part == 'uebersterblichkeitblock' || debug) && (
        <Block style='b' title={'Übersterblichkeit'}>
          <Uebersterblichkeit />
        </Block>
      )} */}
    </AppContainer>
  )
}

const Block = ({
  style = 'a',
  title,
  children,
}: {
  style?: 'a' | 'b'
  title?: string
  children?: ReactNode
}) => {
  const Wrapper = style === 'a' ? GreyBG : WhiteBG
  return (
    <BlockRoot className='BLOCKROOT'>
      {/* <ContentWidth> */}
      <Wrapper>
        {title && <BlockTitle>{title}</BlockTitle>}

        <Col>{children}</Col>
      </Wrapper>
      {/* </ContentWidth> */}
    </BlockRoot>
  )
}
const BlockRoot = styled.div`
  display: flex;
  /* margin-bottom: 30px; */
  overflow: hidden;
  justify-content: center;
`
const BlockTitle = styled.div`
  font-size: 32px;
  line-height: 1.3em;
  max-width: calc(100vw - 40px);
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  /* padding-top: 120px; */
  font-family: var(--font-serif);
  @media screen and (max-width: 711px) {
    padding-top: 60px;
    font-size: 26px;
  }
`
const AppContainer = styled(TamediaStyles)`
  ${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`

const GreyBG = styled.div`
  background-color: var(--grey-segment-bg);
  margin-left: auto;
  margin-right: auto;
  width: 100vw;
  padding-left: 20px;
  max-width: 1200px;
  padding-right: 20px;
  iframe {
    background-color: transparent;
  }
`
const WhiteBG = styled.div`
  background-color: transparent;
  margin-left: auto;
  margin-right: auto;
  width: 100vw;
  padding-left: 20px;
  padding-right: 20px;
  iframe {
    background-color: transparent;
  }
`

const Col = styled.div`
  max-width: 736px;
  padding-top: 60px;
  padding-bottom: 60px;
  margin-left: auto;
  margin-right: auto;
`
export default MainComponent
